import { useState } from 'react';
import useGolfOdds from '../../hooks/useGolfOdds';
import GolfTable from './GolfTable';

export default function GolfBoard({ oddsFormat }) {
  const { tournaments, loading, error, refetch } = useGolfOdds();
  const [active, setActive] = useState(0);

  return (
    <div className="max-w-[1400px] mx-auto px-4 py-4">
      <div className="flex items-center justify-between mb-3">
        {tournaments.length > 1 && (
          <div className="flex bg-[#f1f5f9] dark:bg-[#151a25] rounded p-0.5">
            {tournaments.map((t, i) => (
              <button key={t.sport.key} onClick={() => setActive(i)}
                className={`px-3 py-1 rounded text-[11px] font-medium transition-colors duration-150 ${active === i ? 'bg-[#3b82f6] text-white' : 'text-[#64748b] dark:text-[#8892a8]'}`}>
                {t.sport.title}
              </button>
            ))}
          </div>
        )}
        <button onClick={refetch} disabled={loading}
          className="p-1.5 rounded text-[#64748b] dark:text-[#505a6e] hover:text-[#1e293b] dark:hover:text-[#e2e8f0] hover:bg-[#f1f5f9] dark:hover:bg-[#151a25] transition-colors duration-150 disabled:opacity-40">
          <svg className={`w-3.5 h-3.5 ${loading ? 'animate-spin' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      </div>

      {error && <div className="rounded bg-[rgba(239,68,68,0.06)] dark:bg-[rgba(239,68,68,0.08)] border border-[#fecaca] dark:border-[#7f1d1d] px-3 py-2 mb-3"><p className="text-[#ef4444] text-[11px]">{error}</p><button onClick={refetch} className="text-[10px] text-[#ef4444] underline mt-1">Retry</button></div>}

      {loading ? (
        <div className="space-y-px">{[...Array(8)].map((_, i) => <div key={i} className="h-9 skeleton" />)}</div>
      ) : tournaments.length === 0 ? (
        <div className="text-center py-16"><p className="text-[#8892a8] text-sm">No active tournaments.</p></div>
      ) : (
        <GolfTable tournament={tournaments[active]} oddsFormat={oddsFormat} />
      )}
    </div>
  );
}
